import { createSlice } from "@reduxjs/toolkit"
//import axios from 'axios';


const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("siren") !== null && localStorage.getItem("siren") !== undefined && localStorage.getItem("siren") !== "") {

    data = [JSON.parse(localStorage.getItem("siren"))]

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {

        getdatasiren: (state, action) => {

            return action.payload.data || [];

        },

        logoutsiren: (state, action) => {


            localStorage.clear()
            state = []


        },

        updatesirendata: (state, action) => {


            return action.payload.data || [];

        },


    }
})

export const {  getdatasiren } = Insider.actions;
export default Insider.reducer;